import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login";
import MainFrame from "@/views/MainFrame";
import Children from "@/views/Children";
import Scheduler from "@/views/Scheduler";
import PerformedHours from "@/views/PerformedHours";
import Expense from "@/views/Expense";
import store from '../store'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/index.js",
    name: "Login from index",
    component: Login
  },
  {
    path: "/main",
    name: "Main",
    component: MainFrame,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "/enfants",
        name: "Children",
        component: Children,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: "/horaire",
        name: "Scheduler",
        component: Scheduler,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/heures_prestees",
        name: "PerformedHours",
        component: PerformedHours,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/depenses",
        name: "Expense",
        component: Expense,
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});


router.beforeEach( (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth &&   !store.getters.user.isAuthenticated){
    next('/');
  }else{
    next();
  }
})

export default router;
